import * as Actions from '../../../store/batches/batches.actions';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

const initialState = {
  isLoading: false,
  errorOccurred: false,
  hasNameConflict: false,
};

// TODO: see if there is a way to chain the two identicle handlers below
const actionHandlerMap = {
  [Actions.CREATE_BATCH_WITH_SALES_ORDERS_REQUEST]: (state) => {
    return {
      ...state,
      isLoading: true,
      errorOccurred: false,
      hasNameConflict: false,
    };
  },
  [Actions.CREATE_BATCH_WITH_SALES_ORDERS_SUCCESS]: (state) => {
    return {
      ...state,
      ...initialState,
    };
  },
  [Actions.SALES_ORDER_FULFILLMENT_PLANS_BLOCKED_FROM_BATCH]: (state, { fulfillmentPlansInOtherBatches }) => {
    // TODO: This appears to be the only slice of this code used.
    return {
      ...state,
      fulfillmentPlansInOtherBatches,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './with-sales-orders.reducer.metadata';
